import React from "react";
import "./UiBadge.css";

const UI_BADGE_TYPE = {
  SMALL: "size-small",
  MEDIUM: "size-medium",
  LARGE: "size-large",
};

export { UI_BADGE_TYPE };

const UiBadge = ({
  content,
  classNames = [],
  disabled,
  badgeUiType = [UI_BADGE_TYPE.SMALL],
  style,
  ...props
}) => {
  const badgeUiTypeSet = new Set(Object.values(UI_BADGE_TYPE));
  const badgeUiTypeClass = badgeUiType
    .filter((type) => badgeUiTypeSet.has(type))
    .join(" ");
  const classNamesSet = new Set(classNames);
  classNames = Array.from(classNamesSet).join(" ");
  const badgeClassNames = `ui-badge ${badgeUiTypeClass} ${classNames}`;
  return (
    <React.Fragment>
      <span
        style={style}
        className={badgeClassNames}
        data-disabled={disabled}
        {...props}
      >
        {content}
      </span>
    </React.Fragment>
  );
};

export default UiBadge;
